module.exports = __webpack_public_path__ + "static/discover-4cbe2b8f13c906efe1dd1a6efd58347b.png";